const DashboardInsightsSection = () => {
  return (
    <section className="py-24 px-6 sm:px-12 text-gray-900">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Texto */}
        <div className="text-center lg:text-left">
          <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-800/80">
            Estratégia guiada por dados
          </h3>
          <h2 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-gray-900">
            Dados 360º sobre as visitas da sua Vintree
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-800/90 max-w-xl mx-auto lg:mx-0">
            Descubra quais produtos despertam mais interesse, entenda o
            comportamento dos visitantes, veja tendências semanais, cliques em
            canais de contato e muito mais. Um painel completo que revela o que
            seu público quer — e quando quer.
          </p>
        </div>

        {/* Mockup estático do dashboard */}
        <div className="relative w-full max-w-sm mx-auto aspect-[9/16]">
          <img
            src="/mockups/mockup-dashboard.png"
            alt="Dashboard Vintree"
            className="absolute top-0 left-0 w-full h-full object-cover rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
};

export default DashboardInsightsSection;
